module.exports = __webpack_public_path__ + "img/clock.5200ef0b.svg";